export default __webpack_public_path__ + "static/media/settings.549c1d50.svg";